import { css } from 'emotion';
import themeConfig from '@lyearn-team/theme-config';

export const imageWrapper = css`
  max-width: 150px;
  margin: 0 auto 41px;
  pointer-events: none;
  user-select: none;

  & img {
    width: 65px;
    margin: auto;
    height: auto;
    display: block;
  }
`;

export const mainText = css`
  font-stretch: normal;
  font-style: normal;
  line-height: 1.44;
  margin: 0 auto;
  margin-bottom: 15px;
  text-align: center;
`;

export const subText = css`
  margin: 0 auto;
  margin-bottom: 25px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.71;
  text-align: center;
`;

export const closeIconWrapper = css`
  position: absolute;
  right: 20px;
  top: 20px;
  fill: ${themeConfig.color.dark.copper};
  cursor: pointer;
`;

export const popup = css`
  overflow: auto;
  width: 436px !important;
  min-width: 436px !important;
  min-height: 321px;
  display: flex;
  justify-content: center;
  position: relative;
`;
